var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GET_COLLECTIONS_BY_HANDLE = exports.GET_COLLECTION_PAGINATED_PRODUCT_COMPLETE = exports.GET_COLLECTION_PRODUCT_COMPLETE = exports.GET_COLLECTION_PRODUCT_REFERENCES = exports.GET_COLLECTION = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const productFragment_1 = require("../fragments/productFragment");
const collectionFragment_1 = require("../fragments/collectionFragment");
exports.GET_COLLECTION = (0, graphql_tag_1.default)`
  query ($countryCode: CountryCode!, $handle: String!) @inContext(country: $countryCode) {
    collection: collectionByHandle(handle: $handle) {
      ...CollectionFragment
    }
  }
  ${collectionFragment_1.COLLECTION_FRAGMENT}
`;
exports.GET_COLLECTION_PRODUCT_REFERENCES = (0, graphql_tag_1.default)`
  query ($countryCode: CountryCode!, $handle: String!, $firstProducts: Int) @inContext(country: $countryCode) {
    collection: collectionByHandle(handle: $handle) {
      ...CollectionFragment
      products(first: $firstProducts) {
        edges {
          node {
            id
            handle
          }
        }
      }
    }
  }
  ${collectionFragment_1.COLLECTION_FRAGMENT}
`;
exports.GET_COLLECTION_PRODUCT_COMPLETE = (0, graphql_tag_1.default)`
  query (
    $countryCode: CountryCode!
    $handle: String!
    $firstCollections: Int
    $firstImages: Int
    $firstMedia: Int
    $metafieldIdentifiers: [HasMetafieldsIdentifier!]!
    $firstProducts: Int
    $firstVariants: Int
    $afterVariants: String
  ) @inContext(country: $countryCode) {
    collection: collectionByHandle(handle: $handle) {
      ...CollectionFragment
      products(first: $firstProducts) {
        edges {
          node {
            ...ProductFragment
          }
        }
      }
    }
  }
  ${collectionFragment_1.COLLECTION_FRAGMENT}
  ${productFragment_1.PRODUCT_FRAGMENT}
`;
exports.GET_COLLECTION_PAGINATED_PRODUCT_COMPLETE = (0, graphql_tag_1.default)`
  query (
    $after: String
    $before: String
    $countryCode: CountryCode!
    $handle: String!
    $firstCollections: Int
    $firstImages: Int
    $firstMedia: Int
    $metafieldIdentifiers: [HasMetafieldsIdentifier!]!
    $firstProducts: Int
    $lastProducts: Int
    $firstVariants: Int
    $afterVariants: String
  ) @inContext(country: $countryCode) {
    collection: collectionByHandle(handle: $handle) {
      ...CollectionFragment
      products(first: $firstProducts, last: $lastProducts, before: $before, after: $after) {
        pageInfo {
          hasNextPage
          hasPreviousPage
          endCursor
          startCursor
        }
        edges {
          node {
            ...ProductFragment
          }
        }
      }
    }
  }
  ${collectionFragment_1.COLLECTION_FRAGMENT}
  ${productFragment_1.PRODUCT_FRAGMENT}
`;
const GET_COLLECTIONS_BY_HANDLE = handles => (0, graphql_tag_1.default)`
  query(
    $countryCode: CountryCode!
    $firstCollections: Int
    $firstImages: Int
    $firstMedia: Int
    $metafieldIdentifiers: [HasMetafieldsIdentifier!]!
    $firstProducts: Int
    $firstVariants: Int
    $afterVariants: String
  ) @inContext(country: $countryCode) {
    ${handles === null || handles === void 0 ? void 0 : handles.map(handle => `
      collection${handle.replace(/-/g, "")}: collectionByHandle(handle: "${handle}") {
        ...CollectionFragment
        products(first: $firstProducts) {
          edges {
            node {
              ...ProductFragment
            }
          }
        }
      }
    `)}
  }
  ${collectionFragment_1.COLLECTION_FRAGMENT}
  ${productFragment_1.PRODUCT_FRAGMENT}
`;
exports.GET_COLLECTIONS_BY_HANDLE = GET_COLLECTIONS_BY_HANDLE;